export default __webpack_public_path__ + "static/media/glyphicons-halflings-regular.060b2710.svg";